// Plain template string on purpose: codegen.yml scans `src/**/*.ts` and would
// try to validate any `gql`-tagged or GraphQL-magic-comment-marked operation
// against this app's own backend schema, which does not define `shared.recordUserEvent`.
// The mutation targets the centralized console GraphQL endpoint instead and is
// sent via plain fetch, so keeping it as an untagged string keeps codegen green.
export const RECORD_USER_EVENT = `
  mutation RecordUserEvent($input: RecordUserEventInput!) {
    shared {
      recordUserEvent(input: $input) {
        success
        errors {
          message
          type
        }
      }
    }
  }
`;
